var map = {
	"pages/account/account.module": [
		1230,
		13
	],
	"pages/account/modal-bank-details/modal-bank-details.module": [
		1231,
		19
	],
	"pages/account/modal-banks/modal-banks.module": [
		1232,
		73
	],
	"pages/account/modal-cancel-subscription/modal-cancel-subscription.module": [
		1233,
		54
	],
	"pages/account/modal-payment-details/modal-payment-detail.module": [
		1234,
		72
	],
	"pages/category/category.module": [
		1235,
		10
	],
	"pages/category/products/products.module": [
		1236,
		27
	],
	"pages/category/products/registration/modal-add-complement/modal-add-complement.module": [
		1237,
		12
	],
	"pages/category/products/registration/modal-add-complement/modal-add-option/modal-add-option.module": [
		1239,
		38
	],
	"pages/category/products/registration/modal-help-complement/modal-help-complement.module": [
		1238,
		89
	],
	"pages/category/products/registration/product-registration.module": [
		1260,
		5
	],
	"pages/email-confirmation/email-confirmation.module": [
		1240,
		53
	],
	"pages/forgot-password/forgot-password.module": [
		1242,
		71
	],
	"pages/help/help.module": [
		1241,
		70
	],
	"pages/home/home.module": [
		1243,
		41
	],
	"pages/login/login.module": [
		1244,
		69
	],
	"pages/maintenance/maintenance.module": [
		1245,
		88
	],
	"pages/map/map.module": [
		1246,
		68
	],
	"pages/modal-business-type/modal-business-type.module": [
		1247,
		52
	],
	"pages/modal-card/modal-card.module": [
		1248,
		51
	],
	"pages/modal-countries/modal-countries.module": [
		1250,
		67
	],
	"pages/modal-notification-permission/modal-notification-permission.module": [
		1249,
		87
	],
	"pages/modal-receivable-news/modal-receivable-news.module": [
		1251,
		86
	],
	"pages/modal-reservation-hours-config/modal-reservation-hours-config.module": [
		1252,
		85
	],
	"pages/modal-stores/modal-stores.module": [
		1253,
		66
	],
	"pages/modal-translation/modal-translation.module": [
		1254,
		46
	],
	"pages/modal-trial-expired/modal-trial-expired.module": [
		1256,
		84
	],
	"pages/modal-update-password/modal-update-password.module": [
		1255,
		65
	],
	"pages/modal-welcome/modal-welcome.module": [
		1257,
		83
	],
	"pages/orders/modal-change-table/modal-change-table.module": [
		1258,
		64
	],
	"pages/orders/modal-order-detail/modal-order-detail.module": [
		1259,
		37
	],
	"pages/orders/modal-print-hint/modal-print-hint.module": [
		1261,
		82
	],
	"pages/orders/modal-reject-order/modal-reject-order.module": [
		1262,
		26
	],
	"pages/orders/order-reservation-config/first-step/order-reservation-first-step.module": [
		1263,
		17
	],
	"pages/orders/order-reservation-config/second-step/order-reservation-second-step.module": [
		1264,
		36
	],
	"pages/orders/order-reservation-config/third-step/order-reservation-third-step.module": [
		1265,
		16
	],
	"pages/orders/orders.module": [
		1266,
		7
	],
	"pages/orders/popover-order-filter/popover-order-filter.module": [
		1267,
		81
	],
	"pages/passwords/passwords.module": [
		1269,
		63
	],
	"pages/place/bind-store/bind-store.module": [
		1268,
		62
	],
	"pages/place/details/place-details.module": [
		1270,
		6
	],
	"pages/place/home/place-home.module": [
		1271,
		25
	],
	"pages/place/modal-store-detail/modal-store-detail.module": [
		1272,
		61
	],
	"pages/place/statistics/statistics.module": [
		1283,
		3
	],
	"pages/plan-subscription/modal-payment/modal-payment.module": [
		1273,
		24
	],
	"pages/plan-subscription/plan-subscription.module": [
		1274,
		23
	],
	"pages/queue/modal-queue-detail/modal-queue-detail.module": [
		1275,
		45
	],
	"pages/queue/modal-save-queue/modal-save-queue.module": [
		1276,
		60
	],
	"pages/queue/queue-config/queue-config.module": [
		1277,
		44
	],
	"pages/queue/queue.module": [
		1278,
		9
	],
	"pages/rating/modal-answer-comment/modal-answer-comment.module": [
		1279,
		43
	],
	"pages/rating/order-rating/order-rating.module": [
		1280,
		50
	],
	"pages/rating/rating.module": [
		1281,
		8
	],
	"pages/receivables/modal-forecast-details/modal-forecast-details.module": [
		1282,
		80
	],
	"pages/receivables/receivables.module": [
		1284,
		1
	],
	"pages/reservation/modal-cancel-reservation/modal-cancel-reservation.module": [
		1285,
		49
	],
	"pages/reservation/modal-detail-reservation/modal-detail-reservation.module": [
		1286,
		59
	],
	"pages/reservation/modal-report/modal-report-reservation.module": [
		1287,
		79
	],
	"pages/reservation/modal-save-reservation/modal-save-reservation.module": [
		1288,
		40
	],
	"pages/reservation/reservation-config/first-step/first-step.module": [
		1289,
		21
	],
	"pages/reservation/reservation-config/fourth-step-table/fourth-step-table.module": [
		1290,
		35
	],
	"pages/reservation/reservation-config/reservation-config.module": [
		1295,
		20
	],
	"pages/reservation/reservation-config/second-step-table/second-step-table.module": [
		1291,
		34
	],
	"pages/reservation/reservation-config/second-step/second-step.module": [
		1292,
		33
	],
	"pages/reservation/reservation-config/third-step-table/third-step-table.module": [
		1293,
		32
	],
	"pages/reservation/reservation-config/third-step/third-step.module": [
		1294,
		22
	],
	"pages/reservation/reservation-list/reservation-list.module": [
		1296,
		15
	],
	"pages/settings/settings.module": [
		1297,
		58
	],
	"pages/settings/store-intern-registration/store-intern-registration.module": [
		1298,
		31
	],
	"pages/statistics/modal-report/modal-report.module": [
		1299,
		78
	],
	"pages/statistics/orders/statistics.module": [
		1300,
		0
	],
	"pages/statistics/reservations/reservation-statistics.module": [
		1301,
		2
	],
	"pages/store/details/modal-add-tables/modal-add-tables.module": [
		1302,
		14
	],
	"pages/store/details/modal-delivery/modal-delivery.module": [
		1303,
		30
	],
	"pages/store/details/modal-delivery/modal-fee/modal-fee.module": [
		1304,
		42
	],
	"pages/store/details/modal-qrcode/modal-qrcode.module": [
		1305,
		48
	],
	"pages/store/details/store-details.module": [
		1306,
		4
	],
	"pages/store/registration/store-registration.module": [
		1307,
		18
	],
	"pages/tables-payment/modal-customer-orders/modal-customer-orders.module": [
		1308,
		11
	],
	"pages/tables-payment/popover-filter/popover-filter.module": [
		1309,
		77
	],
	"pages/tables-payment/popover-orders-table/popover-orders-table.module": [
		1310,
		76
	],
	"pages/tables-payment/tables-payment.module": [
		1311,
		47
	],
	"pages/tips/tips-item/tips-item.module": [
		1312,
		57
	],
	"pages/tips/tips.module": [
		1313,
		56
	],
	"pages/user/modal-add-user/modal-add-user.module": [
		1314,
		29
	],
	"pages/user/user.module": [
		1315,
		28
	],
	"pages/whats-new/whats-new.module": [
		1316,
		55
	],
	"shared/components/business-hour/modal-business-hours/modal-business-hours.module": [
		1317,
		39
	],
	"shared/components/popover-tour/popover-tour.module": [
		1318,
		75
	],
	"shared/components/popover/popover.module": [
		1319,
		74
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 431;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 431
// module chunks = 90